/**
 * Green Flag — FloatingActionButton
 *
 * The 70px circular lift-shadowed buttons used on swipe/profile-review
 * ("pass" = red X, "like" = brand heart). No stroke — the shadow carries
 * the depth.
 */

import { chakra, type HTMLChakraProps } from "@chakra-ui/react";
import { forwardRef } from "react";

export interface FloatingActionButtonProps extends HTMLChakraProps<"button"> {
  size?: number;
}

export const FloatingActionButton = forwardRef<HTMLButtonElement, FloatingActionButtonProps>(
  function FloatingActionButton({ size = 70, children, ...rest }, ref) {
    return (
      <chakra.button
        ref={ref}
        type="button"
        layerStyle="floating"
        border="0"
        cursor="pointer"
        w={`${size}px`}
        h={`${size}px`}
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        transitionProperty="transform, filter"
        transitionDuration="fast"
        _hover={{ filter: "brightness(1.04)" }}
        _active={{ transform: "translateY(1px)" }}
        {...rest}
      >
        {children}
      </chakra.button>
    );
  }
);
